import {
  AmexCard,
  ApplePayCard,
  BancontactCard,
  DiscoverCard,
  EpsCard,
  GooglePayCard,
  IdealCard,
  KlarnaCard,
  LinkPayCard,
  MastercardCard,
  P24Card,
  PayPalCard,
  VisaCard,
} from '../icons';

interface PaymentMethod {
  name: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  optional?: boolean;
}

export const paymentMethods: PaymentMethod[] = [
  { name: 'Mastercard', icon: MastercardCard },
  { name: 'Visa', icon: VisaCard },
  { name: 'Amex', icon: AmexCard },
  { name: 'Discover', icon: DiscoverCard },
  { name: 'Apple Pay', icon: ApplePayCard },
  { name: 'Google Pay', icon: GooglePayCard },
  { name: 'Link', icon: LinkPayCard },
  { name: 'PayPal', icon: PayPalCard },
  { name: 'iDEAL', icon: IdealCard },
  { name: 'Klarna', icon: KlarnaCard },
  { name: 'Bancontact', icon: BancontactCard },
  { name: 'eps', icon: EpsCard, optional: true },
  { name: 'P24', icon: P24Card, optional: true },
];
